// React
import React, { Component, Fragment } from "react";

// Component
import Section from "./spocketDeals/Section";
import Container from "../component/Container";

// Libs
import DocumentTitle from "react-document-title";

// Image
import rocketIllustration from "../images/rocket-illustration.svg";

// Style
import "./SpocketDeals.css";

const Banner = () => {
  return (
    <div className="spocket-deals__banner">
      <img src={rocketIllustration} alt="RocketI llustration" />
      <div className="spocket-deals__banner-text">
        <span>
          Exclusive deals on top-notch eCommerce tools to boost your growth
        </span>
        <span>
          Save up to $11,000/year on the best apps to help you fast-track your
          sales.
        </span>
      </div>
    </div>
  );
};

class SpocketDeals extends Component {
  state = {
    imageLoaded: false
  };

  componentDidMount() {
    const placeholderImg = new Image();
    placeholderImg.src = rocketIllustration;
    placeholderImg.onload = () => {
      this.setState({
        imageLoaded: true
      });
    };
  }

  render() {
    return (
      <Fragment>
        <DocumentTitle title="Deals - Spocket" />
        {this.state.imageLoaded && (
          <div className="spocket-deals__container">
            <h1>Spocket Deals</h1>
            <Banner />
            <div className="spocket-deals__sections">
              <Section type="marketing" />
              <Section type="conversion" />
              <Section type="design" />
              <Section type="shopifyExperts" />
              <Section type="support" />
              <Section type="orderShipping" />
              <Section type="designGraphics" />
              <Container alignItems="center" theme="dropShadow">
                <div className="spocket-deals__footer">
                  <span> Many more exclusive deals are coming.</span> Check back
                  soon!
                </div>
              </Container>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default SpocketDeals;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/SpocketDeals.js